import React, { useEffect, useState } from "react";
import {
  Card,
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  Checkbox,
  Radio,
  Typography,
  Row,
  Col,
  Divider,
  Alert,
  InputNumber,
  Modal
} from "antd";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import dayjs from "dayjs";
import SearchNcm from "./seachArmador/search-ncm";
import SearchArmador from "./seachArmador/search-armador";
import HeaderPage from "../HeaderPage";
import Sidebar from "../Sidebar";
import "./styles.css";
import { MailOutlined, WhatsAppOutlined } from '@ant-design/icons';

const { Option } = Select;
const { Title } = Typography;

interface ItemSelect {
  idItem: any;
  name: string;
}

interface PortoSelect {
  port_id: string;
  port_name: string;
}

const CotacoesNAC = () => {
  const [form] = Form.useForm();
  const [nomeEmbarcador, setNomeEmbarcador] = useState("");
  const [telefoneEmbarcador, setTelefoneEmbarcador] = useState("");
  const [portosEmbarque, setPortosEmbarque] = useState<PortoSelect[]>([]);
  const [portosDescarga, setPortosDescarga] = useState<PortoSelect[]>([]);
  const [tiposContainer, setTiposContainer] = useState<ItemSelect[]>([]);
  const email = localStorage.getItem("user_email");
  const [selectedArmadores, setSelectedArmadores] = useState([]);
  const [selectedContainerType, setSelectedContainerType] = useState("");
  const [selectedIMO, setSelectedIMO] = useState("nao");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);

  let navigate = useNavigate();

  useEffect(() => {
    api.get("filters/portos_embarque").then((response) => {
      setPortosEmbarque(response.data);
    });

    api.get("filters/portos_descarga").then((response) => {
      setPortosDescarga(response.data);
    });

    api.get("filters/tipos_container").then((response) => {
      setTiposContainer(response.data);
    });

    api
      .post("/user/find_user", { email })
      .then((resp) => {
        setNomeEmbarcador(resp.data.user.name);
        setTelefoneEmbarcador(resp.data.user.telefone);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [email]);

  const onFinish = async (values) => {
    setLoading(true);
    setError("");

    try {
      const dataToSend = {
        embarcador_nome: nomeEmbarcador,
        telefone_embarcador: telefoneEmbarcador,
        embarcador_email: email,
        data_embarque: values.data_embarque?.format("DD-MM-YYYY") ?? null,
        ...values,
        Armadores: values.armador_array.join(',')
      };

      await api.post("booking/save_quotation", dataToSend);
      setIsModalVisible(true);
    } catch (err) {
      setError("Ocorreu um problema ao reservar o booking");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const handleContainerTypeChange = (value) => {
    setSelectedContainerType(value);
  };

  const handleIMOChange = (value) => {
    setSelectedIMO(value);
  };

  const handleArmadorChange = (value) => {
    setSelectedArmadores(value);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    navigate("/");
  };

  const goToFornecedores = () => {
    navigate("/fornecedores");
  };

  return (
    <div className="flex-dashboard">
      <Sidebar elementoAtivo="cotacoes_nac" />
      <main>
        <HeaderPage nomeOpcao="Cotações NAC" />
        <div className="main-content">
          <div className="main-content-title">
            <Button onClick={goToFornecedores} type="primary" style={{ float: 'right' }}>
              Suppliers
            </Button>
          </div>

          <Card title="Formulário de Cotação NAC" style={{ width: '100%', marginTop: '40px' }}>
            {error && <Alert message={error} type="error" showIcon style={{ marginBottom: 16 }} />}

            <Form
              form={form}
              name="cotacaoNAC"
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    label="Shipper"
                    name="shipper"
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Consignee"
                    name="consignee"
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Port of loading"
                    name="selectPortoEmbarque"
                    rules={[{ required: true, message: 'Please select the port of loading!' }]}
                  >
                    <Select
                      showSearch
                      placeholder="Select the port"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {portosEmbarque.map(porto => (
                        <Option key={porto.port_id} value={porto.port_id}>
                          {porto.port_name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    label="Port of discharge"
                    name="selectPortoDescarga"
                    rules={[{ required: true, message: 'Please select the port of discharge!' }]}
                  >
                    <Select
                      showSearch
                      placeholder="Select the port"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {portosDescarga.map(porto => (
                        <Option key={porto.port_id} value={porto.port_id}>
                          {porto.port_name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Commodity"
                    name="selectMercadoria"
                  >
                    <SearchNcm />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Container Type"
                    name="tipoContainer"
                    rules={[{ required: true, message: 'Please select the type of container!' }]}
                  >
                    <Select onChange={handleContainerTypeChange}>
                      <Option value="">Select</Option>
                      <Option value="ST20">20' Standard</Option>
                      <Option value="ST40">40' Standard</Option>
                      <Option value="HQ40">40' High Cube</Option>
                      <Option value="40RE">40' Reefer</Option>
                      <Option value="20RE">20' Reefer</Option>
                      <Option value="40NOR">40' Non Operation Reefer</Option>
                      <Option value="20FT">20' Flat Rack</Option>
                      <Option value="40FT">40' Flat Rack</Option>
                      <Option value="20OT">20' Open Top</Option>
                      <Option value="40OT">40' Open Top</Option>
                      <Option value="20PL">20' Platform</Option>
                      <Option value="40PL">40' Platform</Option>
                      <Option value="20TK">20' Isotank</Option>
                      <Option value="40TK">40' Isotank</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    label="Container Quantity"
                    name="qtdContainers"
                    rules={[{ required: true, message: 'Please enter the quantity!' }]}
                  >
                    <InputNumber min={1} value={1} style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Weight (KG)"
                    name="peso"
                    rules={[{ required: true, message: 'Please enter the weight!' }]}
                  >
                    <InputNumber
                      min={0}
                      step={0.01}
                      style={{ width: '100%' }}
                      formatter={(value) => `${value} KG`}
                      parser={(value) => value!.replace(' KG', '')}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Shipping Date"
                    name="data_embarque"
                    rules={[{ required: true, message: 'Please select the shipping date!' }]}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      disabledDate={(current) => current && current < dayjs().startOf('day')}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    label="Carriers & Suppliers"
                    name="armador_array"
                  >
                    <SearchArmador />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Incoterm"
                    name="Incoterm"
                  >
                    <Select>
                      <Option value="">Select</Option>
                      <Option value="C&F">C&F</Option>
                      <Option value="CIF">CIF</Option>
                      <Option value="FOB">FOB</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Free Time Origin"
                    name="freetimeOrigem"
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    label="Free Time Destination"
                    name="freetimeDestino"
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Dangerous Cargo"
                    name="CargaEspecial"
                  >
                    <Select onChange={handleIMOChange}>
                      <Option value="nao">Não IMO</Option>
                      <Option value="sim">IMO</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Currency"
                    name="Currency"
                  >
                    <Select>
                      <Option value="dolar">USD - US$</Option>
                      <Option value="real">BRL - R$</Option>
                      <Option value="euro">EUR - €</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    label="Target Ocean Freight"
                    name="targetOceanFreight"
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="conteinerSelf" valuePropName="checked">
                    <Checkbox>I wish to use shipper's</Checkbox>
                  </Form.Item>
                </Col>
              </Row>
              {selectedIMO === "sim" && (
                <div>
                  <Divider orientation="left">Campos Adicionais</Divider>
                  <Row gutter={16}>
                    <Col span={8}>
                      <Form.Item
                        label="Descrição IMO"
                        name="imo"
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
              )}

              {(selectedContainerType === "20OT" ||
                selectedContainerType === "40OT" ||
                selectedContainerType === "20PL" ||
                selectedContainerType === "40PL" ||
                selectedContainerType === "20FT" ||
                selectedContainerType === "40FT") && (
                  <Row gutter={16}>
                    <Col span={8}>
                      <Form.Item
                        label="Dimensões Container"
                        name="dimensoes"
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                  </Row>
                )}

              {(selectedContainerType === "40RE" ||
                selectedContainerType === "20RE") && (
                  <>
                    <Row gutter={16}>
                      <Col span={8}>
                        <Form.Item
                          label="Temperatura Container"
                          name="temperatura"
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={8}>
                        <Form.Item
                          label="Refrigerado"
                          name="refrigerado"
                        >
                          <Radio.Group>
                            <Radio value="sim">Sim</Radio>
                            <Radio value="nao">Não</Radio>
                          </Radio.Group>
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                )}

              <Form.Item style={{ textAlign: 'center', marginTop: 24 }}>
                <Button type="primary" htmlType="submit" loading={loading}>
                  Request NAC
                </Button>
              </Form.Item>
            </Form>
          </Card>

          {/* Success Modal */}
          <Modal
            title="Quotation NAC Processado"
            visible={isModalVisible}
            onOk={handleOk}
            onCancel={handleOk}
            footer={[
              <Button key="submit" type="primary" onClick={handleOk}>
                OK
              </Button>
            ]}
            centered
          >
            <div style={{ textAlign: 'center' }}>
              <p style={{ fontSize: '16px', marginBottom: '20px' }}>
                Em breve um de nossos analistas irá entrar em contato.
              </p>

              <p style={{ marginBottom: '20px' }}>
                Se preferir, fale conosco agora através dos nossos canais:
              </p>

              <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginBottom: '20px' }}>
                <a href="mailto:comercial@zarpar.net" style={{ fontSize: '24px', color: '#1890ff' }}>
                  <MailOutlined />
                </a>
                <a href="https://wa.me/+5511940580365" target="_blank" rel="noopener noreferrer" style={{ fontSize: '24px', color: '#25D366' }}>
                  <WhatsAppOutlined />
                </a>
              </div>

              <p>Ou então enviando email para Central do Cliente:</p>
              <p style={{ fontWeight: 'bold' }}>comercial@zarpar.net</p>
            </div>
          </Modal>
        </div>
      </main>
    </div>
  );
};

export default CotacoesNAC;